export const getFileType = (file: File): string => {
  // Handle .msg files separately since they are not correctly identified by the browser
  // See: https://www.outsystems.com/forums/discussion/69389/how-to-get-right-mime-type-for-msg-file-while-uploading-file/#
  if (file.name.endsWith('.msg')) {
    return 'application/vnd.ms-outlook';
  }
  return file.type;
};
